import axios from 'axios';

export function handleSupportRequests() {
  const form = document.querySelector('.js-support-form');

  if (!form) return;

  const genericErrorMessage = document.querySelector('.js-form-error-message');
  const validationErrorMessage = document.querySelector(
    '.js-validation-error-message'
  );

  const successUrl = form.dataset.successUrl || '/';

  form.addEventListener('submit', (e) => {
    e.preventDefault();
    clearErrors();

    const data = new FormData(form);

    const apiRequest = axios({
      method: 'POST',
      url: '/api/support-request',
      data,
    });

    apiRequest
      .then((response) => {
        if (response.status === 201) {
          onSubmitSuccess();
        }
      })
      .catch((error) => {
        onSubmitError(error);
      });
  });

  function onSubmitSuccess() {
    window.location.href = successUrl;
  }

  function onSubmitError(error) {
    if (error.response) {
      const { response } = error;

      if (response.status === 422) {
        handleValidationErrors(response);
      } else {
        showGenericErrorMessage();
      }
    } else {
      showGenericErrorMessage();
    }
  }

  function handleValidationErrors(response) {
    const { errors } = response.data;

    for (const key of Object.keys(errors)) {
      const formInput = form.querySelector(`[name="${key}"]`);

      if (formInput) {
        const inputWrapper = formInput.closest('.js-form-input-wrapper');

        if (inputWrapper) {
          const errorEl = document.createElement('p');
          errorEl.classList.add('mt-2', 'text-red-500', 'js-validation-error');
          errorEl.textContent = errors[key][0];
          inputWrapper.classList.add('has-errors');
          inputWrapper.appendChild(errorEl);
        }
      }
    }

    validationErrorMessage.classList.remove('hidden');
    validationErrorMessage.scrollIntoView({
      behavior: 'smooth',
    });
  }

  function clearErrors() {
    genericErrorMessage.classList.add('hidden');
    validationErrorMessage.classList.add('hidden');

    // Clear validation errors
    const wrappersWithErrors = form.querySelectorAll(
      '.js-form-input-wrapper.has-errors'
    );

    for (const wrapper of wrappersWithErrors) {
      wrapper.classList.remove('has-errors');
    }

    const validationErrors = form.querySelectorAll('.js-validation-error');

    if (!validationErrors.length) return;

    for (const error of validationErrors) {
      error.parentElement.removeChild(error);
    }
  }

  function showGenericErrorMessage() {
    genericErrorMessage.classList.remove('hidden');
    genericErrorMessage.scrollIntoView({
      behavior: 'smooth',
    });
  }
}
